import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageMeta, siteUrl, siteName } from '../../data/meta';

/* Find a head tag by selector, creating it when index.html does not carry
   one, and set a single attribute on it. */
const setHead = (selector, make, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = make();
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const meta = (key, name) => () => {
  const el = document.createElement('meta');
  el.setAttribute(key, name);
  return el;
};

const link = (rel) => () => {
  const el = document.createElement('link');
  el.setAttribute('rel', rel);
  return el;
};

/**
 * Keeps the description, canonical address and share tags in step with the
 * route. The tab title is always the bare site name, by request; the
 * per-route title only reaches the Open Graph tags. Must sit inside the
 * router, like ScrollToTopOnNavigate.
 *
 * The canonical is deliberately absent from index.html and only ever set
 * here: a static one would name the home page as the canonical of every
 * route, which is worse than having none. A trailing slash is folded away so
 * /about/ and /about resolve to the same address.
 */
const PageMeta = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname.replace(/\/+$/, '') || '/';
    const m = pageMeta[path] || pageMeta['/'];
    const url = path === '/' ? `${siteUrl}/` : `${siteUrl}${path}`;

    document.title = siteName;
    setHead('meta[name="description"]', meta('name', 'description'), 'content', m.description);
    setHead('link[rel="canonical"]', link('canonical'), 'href', url);
    setHead('meta[property="og:title"]', meta('property', 'og:title'), 'content', m.title);
    setHead('meta[property="og:description"]', meta('property', 'og:description'), 'content', m.description);
    setHead('meta[property="og:url"]', meta('property', 'og:url'), 'content', url);
  }, [pathname]);

  return null;
};

export default PageMeta;
